import React from 'react';
import { Datepicker } from 'flowbite-react';
import { formatDateToYYYYMMDDInAppTimezone } from '../../utils/constants/timezone';

export const DatePickers = ({ selectedDate, setSelectedDate }) => {

    const handleDatePickerChange = (date) => {
        setSelectedDate(formatDateToYYYYMMDDInAppTimezone(date));
    };

    return (
        <>
            <div >
                <Datepicker
                    value={selectedDate}
                    onSelectedDateChanged={handleDatePickerChange}
                    id='dob'
                    style={{background:'wjite'}}
                    name='dob'
                    className="focus:ring-blue-500 bg-white-50 focus:border-blue-500 block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder={"DOB"}
                    maxDate={new Date()}
                />
            </div>
        </>
    );
};
